import {color, type} from "common/tokens";
import PublishIcon from '@mui/icons-material/Publish';
import "components/styles/AgreeabilityScale.scss";
import {concat, isEmpty, map, without} from 'lodash';
import React, {useState} from "react";
import {useTranslation} from "react-i18next";

const styles = {
  box: {
    ...type.body,
    backgroundColor: color.SURFACE,
    border: `1px solid ${color.BORDER}`,
    borderRadius: 12,
    color: color.TEXT,
    width: '100%',
    minHeight: 52,
    padding: '14px 16px',
    alignItems: 'center',
    justifyContent: 'space-between',
    display: 'flex',
    boxSizing: 'border-box',
    cursor: 'pointer',
  },
  image: {
    width: 100,
    height: 100,
    borderRadius: 10,
  },
  imageWrapper: {
    position: 'relative',
  }
};

const ImageFileUpload = ({onAnswered, value = []}) => {
  const {t} = useTranslation();

  const [errorMessage, setErrorMessage] = useState("");

  const handleUpload = (e) => {
    setErrorMessage("");
    const uploadedFile = e.target.files[0];
    if (uploadedFile.size > 2000000) {
      setErrorMessage(t('imageMaxSize2MB'))
    } else {
      onAnswered(URL.createObjectURL(e.target.files[0]),e.target.files[0]);
    }
  };

  return (
    <div>
      <input type="file" onChange={handleUpload} id="upload" hidden accept="image/*"/>
      <label htmlFor="upload" style={styles.box}>{t('upload')} <PublishIcon style={{float: 'right', color: "#52B2E2"}}/></label>
      {!isEmpty(errorMessage) &&
      <div style={{
        marginLeft: 16,
        fontSize: 12,
        color: 'red',
        paddingTop: 10
      }}>
        {errorMessage === 'Not an image.' ? t('invalidImageFile') : errorMessage}
      </div>}
    </div>
  );
};


export default (ImageFileUpload);
